import { Modal, ModalBody, Button } from "reactstrap";

interface DeleteModalProps {
  show: boolean;
  onDeleteClick: () => void;
  onCloseClick: () => void;
  recordName?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ 
  show, 
  onDeleteClick, 
  onCloseClick, 
  recordName 
}) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <i className="ri-delete-bin-line display-5 text-danger"></i>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you sure?</h4>
            <p className="text-muted mx-4 mb-0">
              Are you sure you want to remove {recordName ? `"${recordName}"` : "this record"}?
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <Button
            type="button"
            color="light"
            className="w-sm"
            onClick={onCloseClick}
          >
            Close
          </Button>
          <Button
            type="button"
            color="danger"
            className="w-sm"
            onClick={onDeleteClick}
          >
            Yes, Delete It!
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeleteModal;
